import { render, staticRenderFns } from "./IframePageViewCms.vue?vue&type=template&id=3306760b&"
import script from "./IframePageViewCms.vue?vue&type=script&lang=js&"
export * from "./IframePageViewCms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3306760b')) {
      api.createRecord('3306760b', component.options)
    } else {
      api.reload('3306760b', component.options)
    }
    module.hot.accept("./IframePageViewCms.vue?vue&type=template&id=3306760b&", function () {
      api.rerender('3306760b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/IframePageViewCms.vue"
export default component.exports